var _circle, _circle2, _path, _path2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTram3Frontwheels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 68,
    viewBox: "0 0 287 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.7832,
    cy: 35.0469,
    r: 27.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.918,
    cy: 35.0469,
    r: 27.5,
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0599 35.6816H5.69141C5.69175 18.7355 19.4294 4.99805 36.3756 4.99805C53.3219 4.99805 67.0595 18.7355 67.0599 35.6816Z",
    fill: "#9AFF6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69141 35.6816L0.691406 35.6815L0.691303 40.6816H5.69141V35.6816ZM67.0599 35.6816V40.6816H72.06L72.0599 35.6815L67.0599 35.6816ZM5.69141 40.6816H67.0599V30.6816H5.69141V40.6816ZM10.6914 35.6817C10.6917 21.497 22.1908 9.99805 36.3756 9.99805V-0.00195312C16.668 -0.00195312 0.691811 15.974 0.691406 35.6815L10.6914 35.6817ZM36.3756 9.99805C50.5605 9.99805 62.0596 21.497 62.0599 35.6817L72.0599 35.6815C72.0595 15.974 56.0833 -0.00195312 36.3756 -0.00195312V9.99805Z",
    fill: "#9AFF6B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 254.148,
    cy: 33.8555,
    r: 27.5,
    fill: "black",
    stroke: "black",
    strokeWidth: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.082,
    cy: 33.8555,
    r: 27.5,
    fill: "black",
    stroke: "#9AFF6B",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTram3Frontwheels);
export default __webpack_public_path__ + "static/media/tram3-frontwheels.f501d9be9f9151613b0bc5d2bca7dfec.svg";
export { ForwardRef as ReactComponent };